import { useProfile, dayNumberFromStartDate } from '../lib/hooks'
import { TOTAL_DAYS } from '../data/plan'

export default function TopHeader() {
  const { profile } = useProfile()
  const dayNumber = profile?.startDate ? dayNumberFromStartDate(profile.startDate) : 1

  return (
    <header className="top-header">
      <div className="top-header-brand">
        <img src="/health-icons/icon-512.png" alt="" className="top-header-mark" />
        <span className="top-header-name">HEALTHNEST</span>
      </div>
      <span className="top-header-day">DAY {String(dayNumber).padStart(2, '0')} / {TOTAL_DAYS}</span>
    </header>
  )
}
